var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadNative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 40a2.878 2.878 0 0 1-2.1-.9A2.878 2.878 0 0 1 0 37V13.2a2.92 2.92 0 0 1 .25-1.175 3.12 3.12 0 0 1 .65-.975L11.05.9a3.12 3.12 0 0 1 .975-.65A2.92 2.92 0 0 1 13.2 0H29a2.878 2.878 0 0 1 2.1.9A2.878 2.878 0 0 1 32 3v34a3.076 3.076 0 0 1-3 3Zm0-3h26V3H13.3L3 13.3Zm13.1-7.5a1.468 1.468 0 0 0 .55-.1 1.524 1.524 0 0 0 .5-.35l5.7-5.7a1.506 1.506 0 0 0 .425-1.05 1.414 1.414 0 0 0-.425-1.1 1.509 1.509 0 0 0-2.15 0l-3.1 3.1v-8.2a1.5 1.5 0 1 0-3 0v8.2l-3.1-3.1a1.476 1.476 0 0 0-1.025-.425A1.383 1.383 0 0 0 9.4 21.2a1.509 1.509 0 0 0 0 2.15l5.65 5.7a1.524 1.524 0 0 0 .5.35 1.468 1.468 0 0 0 .55.1ZM3 37Z",
    fill: "#185edf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNative);
export default __webpack_public_path__ + "static/media/DownloadNative.e23e7e94bfc18117b5a0ffc07f792caf.svg";
export { ForwardRef as ReactComponent };